import "core-js/modules/es.array.concat.js";
import http from '@/plugins/axios';
import store from '@/store';
var VERSAO = 'v1';
export default {
  get: function get(identificador) {
    return http.apiCore.get("/".concat(VERSAO, "/pesquisa/").concat(identificador));
  },
  enviaRespostas: function enviaRespostas(payload, identificador) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/v2/pesquisa/resposta/").concat(identificador), payload);
  }
};